import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/nis2/measures/')({
  beforeLoad: () => {
    // Generic NIS2 measure links should land on the measure overview instead of
    // the app-wide 404. Specific tasks link directly to /nis2/measures/$code.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/nis2/dashboard', replace: true });
  },
});
